import React from 'react'
import '@tamagui/core/reset.css'
import { Helmet } from 'react-helmet'

// Financial Review Components
import { FinancialProfileScreen } from 'app/features/financial-profile/screen'
import { FinancialInvestmentsScreen } from 'app/features/financial-review/investments/screen'
import { FinancialSnapshot } from 'app/features/financial-review/snapShot/financialSnapshot'
import { FinancialSpending } from 'app/features/financial-review/budgetAnalysis/budgetAnalysis'
import { Recommendations } from 'app/features/financial-review/recommendations/Recommendation'
import { FinancialCashFlow } from 'app/features/financial-review/cash-flow/financialCashFlow'
import { FinancialPlan } from 'app/features/financial-review/financialPlan/financialPlan'
import { KeyInsights } from 'app/features/financial-review/insights/keyInsights'
import { FinancialGoals } from 'app/features/financial-review/financialGoal/financialGoal'
import { ScenarioPlanning } from 'app/features/financial-review/scenarioPlanning/scenarioPlanning'
import { CreateScenario } from 'app/features/financial-review/scenarioPlanning/createScenario/createScenario'

// Settings Components
import { UserProfileScreen } from 'app/features/user-account/screen'
import { MobilePricingPage } from 'app/features/user-account/subscription'
import { SupportedDeviceScreen } from 'app/features/supported-device/screen'

//Advisor
import { AdvisorDetail } from 'app/features/advisor-match/advisor-detail'
import { AdvisorMatch } from 'app/features/advisor-match'

// Other Features
import { Savvy } from 'app/features/savvy/Savvy'
import { HomeScreen } from 'app/features/home/screen'
import { DemoScreen } from 'app/features/demo/screen'
import { UserDetailScreen } from 'app/features/user/detail-screen'
import { ChatDemoScreen } from 'app/features/chat-demo/screen'
import { InternalAdmin } from 'app/features/internal-admin/screen'
import { SimpleText } from '@my/ui'
import { Layout, PublicLayout } from './layout/Layout'
import { PublicTerms } from 'app/features/termsfeed'
import { AuthSignIn } from 'app/features/auth/screen'

const MobileBridge = () => { //https://app.thezillennialadvisors.com/mobile-bridge?universalLinkCallback=true
  const queryParams = new URLSearchParams(window.location.search);
  const universalLinkCallbackTarget = queryParams.get('universalLinkCallback');
  const mobileTarget = queryParams.get('mobile');
  const webTarget = queryParams.get('web');
  if (universalLinkCallbackTarget) {
    window.location.href = 'https://useparity.app/universal-link-callback'; //registration-finished
  }
  else if (mobileTarget) {
    window.location.replace('parity://'+mobileTarget); //registration-finished
  }
  else if (webTarget) {
    const approvedWebTargets = ['parity://universal-link-callback'];
    if (approvedWebTargets.includes(webTarget)) { //https://app.thezillennialadvisors.com/mobile-bridge?web=parity://universal-link-callback
      window.location.replace(webTarget); //registration-finished
    }
  }
  else {
    window.location.replace('/');
  }
  return <></>;
}

// Higher-Order Component for Page Titles
const withTitleHOC = (title: string, node: React.ReactNode, { show, publicLayout }: {show?: boolean; publicLayout?: boolean} = {}) => (
  <>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {publicLayout ? <PublicLayout>{node}</PublicLayout> : <Layout showNav={show ?? true}>{node}</Layout>}
  </>
)
export const noRole = [
]
export const userRoutes = [
  {
    path: '/',
    index: true,
    element: withTitleHOC('Parity | Home', <HomeScreen />),
  },
  {
    path: '/auth-signin',
    element: withTitleHOC('Parity | Auth', <AuthSignIn />),
  },
  {
    path: '/not-supported-device',
    element: withTitleHOC('Parity | Device Not Supported', <SupportedDeviceScreen />, { publicLayout: true }),
  },
  {
    path: '/mobile-bridge',
    element: <MobileBridge />,
  },
  {
    path: 'internal-admin',
    element: withTitleHOC('Parity | Internal-only Admin', <InternalAdmin />),
  },
  {
    path: 'financial-profile',
    element: withTitleHOC('Parity | Financial Profile', <FinancialProfileScreen />),
  },
  {
    path: 'demo',
    element: withTitleHOC('Parity | Plaid Demo', <DemoScreen />),
  },
  {
    path: 'chat-demo',
    element: withTitleHOC('Parity | Chat Demo', <ChatDemoScreen />),
  },
  { path: '/user/:id', element: <UserDetailScreen /> },
  {
    path: 'financial-snapshot',
    element: withTitleHOC('Parity | Financial Snapshot', <FinancialSnapshot />),
  },
  {
    path: 'financial-spending',
    element: withTitleHOC('Parity | Financial Spending', <FinancialSpending />),
  },
  {
    path: 'financial-savingsforecast',
    element: withTitleHOC('Parity | Financial Savings Forecast', <FinancialCashFlow />),
  },
  {
    path: 'financial-plan',
    element: withTitleHOC('Parity | Financial Plan', <FinancialPlan />),
  },
  {
    path: '/key-insights',
    element: withTitleHOC('Parity | Key Insights', <KeyInsights />),
  },
  {
    path: '/financial-goals',
    element: withTitleHOC('Parity | Financial Goals', <FinancialGoals />),
  },
  {
    path: '/recommendations',
    element: withTitleHOC('Parity | Recommendation', <Recommendations />),
  },
  {
    path: 'scenario-planning',
    element: withTitleHOC('Parity | Scenario Planning', <ScenarioPlanning />),
  },
  {
    path: 'create-scenario',
    element: withTitleHOC('Parity | Create Scenario', <CreateScenario />),
  },
  {
    path: 'investments',
    element: withTitleHOC('Parity | Investments', <FinancialInvestmentsScreen />),
  },
  {
    path: 'legal',
    element: withTitleHOC('Parity | Legal Terms', <PublicTerms />, { publicLayout: true }),
  },
  {
    path: 'registration',
    element: withTitleHOC('Parity | User Registration', <UserProfileScreen />, { publicLayout: true }),
  },
  {
    path: 'registration-mobile-subscription',
    element: withTitleHOC('Parity | Mobile Subscription', <MobilePricingPage />, { publicLayout: true }),
  },
/*   {
    path: 'privacyPolicy',
    element: withTitleHOC('Parity | Privacy Policy', <PrivacyPolicy />),
  },
  {
    path: 'term&condition',
    element: withTitleHOC('Parity | Terms And Condition', <TermsAndCondition />),
  }, */
  {
    path: 'savvy',
    element: withTitleHOC('Parity | Savvy', <Savvy />),
  },
  {
    path: 'advisor-match',
    element: withTitleHOC('Parity | Advisor Match', <AdvisorMatch />),
  },
  {
    path: 'advisorDetails',
    element: withTitleHOC('Parity | Advisor Details', <AdvisorDetail />),
  },
]

export const publicRoutesPathPrefixes = ['/legal', '/mobile-bridge'];

function AdvisorDashboard() {
  return <SimpleText>Advisor DashBoard</SimpleText>
}
